import { useCallback } from "react";
import useApi from "./useApi";
import { all } from "axios";

const ADMIN_SETTINGS_BASE = "/admin/admin-settings";

const useAdminSettings = () => {
  const { get, post, put } = useApi();

  // Fetch all settings
  const allSettings = get(ADMIN_SETTINGS_BASE);

  //get employee
  const allEmployees = get("/admin/employees");

  // Update settings (PUT)
  const updateSettingsMutation = put(ADMIN_SETTINGS_BASE, {});

  // Provide a wrapper to always pass { id: '', payload: { settings } } and accept options
  const updateSettings = useCallback(
    (settings, options) => {
      updateSettingsMutation.mutate({ id: "", payload: { settings } }, options);
    },
    [updateSettingsMutation]
  );

  function isEmpty(val) {
    if (val === false) return false; // keep false
    if (val === 0) return false; // keep 0
    if (val == null) return true; // null or undefined
    if (typeof val === "string" && val.trim() === "") return true;
    return false;
  }

  // Upload file (POST with multipart)
  const uploadFileMutation = post(ADMIN_SETTINGS_BASE + "/upload", {
    onSuccess: (data, variables, context) => {
      // if (data.success) {
      //     setLocalSettings(prev => ({
      //         ...prev,
      //         [field]: data.data.url
      //     }));
      // }
    },
  });

  // Reset to defaults (POST)
  const resetToDefaultsMutation = post(ADMIN_SETTINGS_BASE + "/reset", {});

  // Get settings by category
  const getSettingsByCategory = (category) =>
    get(`${ADMIN_SETTINGS_BASE}/category/${category}`);

  // Get setting by key
  const getSettingByKey = (key) => get(`${ADMIN_SETTINGS_BASE}/${key}`);

  // Helper: get setting value from allSettings
  const getSettingValue = useCallback(
    (key, defaultValue = "") => {
      if (allSettings.data && allSettings.data.data) {
        let value = allSettings.data.data[key];

        // empty string, null, or undefined
        if (!isEmpty(value)) {
          return value;
        }

        // return value === "" || value === null ? value : defaultValue;
      }
      return defaultValue;
    },
    [allSettings.data]
  );

  // Helper: set setting value locally (for form state, not persisted)
  // Not needed with React Query, but can be implemented if required
  // const setSettingValue = ...

  return {
    // Query state for all settings
    settings: allSettings.data ? allSettings.data.data : {},
    loading: allSettings.isLoading,
    error: allSettings.isError
      ? allSettings.error?.message || "Failed to load settings"
      : null,
    refetch: allSettings.refetch,

    //all Employees
    GetEmployees: allEmployees,

    // Mutations
    updateSettings,
    updateSettingsStatus: updateSettingsMutation.isLoading,
    updateSettingsError: updateSettingsMutation.isError
      ? updateSettingsMutation.error?.message || "Failed to update settings"
      : null,

    uploadFile: uploadFileMutation.mutate,
    uploadFileStatus: uploadFileMutation.isLoading,
    uploadFileError: uploadFileMutation.isError
      ? uploadFileMutation.error?.message || "Failed to upload file"
      : null,

    resetToDefaults: resetToDefaultsMutation.mutate,
    resetToDefaultsStatus: resetToDefaultsMutation.isLoading,
    resetToDefaultsError: resetToDefaultsMutation.isError
      ? resetToDefaultsMutation.error?.message || "Failed to reset settings"
      : null,

    getSettingsByCategory,
    getSettingByKey,
    getSettingValue,
    // setSettingValue, // Not implemented
  };
};

export default useAdminSettings;
